// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"update_user_details_form-module__formContainer___3nH4G"};